<template>
  <div class="Picker">
    <div class="container container--wide">
      <div
        class="row"
        :class="{ 'centered' : tree.labels.length > 2 }"
      >
        <template
          v-for="label in tree.labels"
        >
          <div
            :class="`col-${
              Math.min (
                3,
                Math.floor (
                  12 / Math.min (
                    tree.labels.length,
                    6
                  )
                )
              )
            }`"
          >
            <label :for="label">{{ capitalize (label) }}</label>
            <select
              :id="label"
              :ref="label"
              :disabled="options (label).length <= 1"
              v-model="selected [label]"
              @change="onChange (label)"
            >
              <option
                v-for="option in options (label)"
                :selected="option === selected [label]"
              >
                {{ option }}
              </option>
            </select>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { capitalize } from '@/legacy/lib//template';
  import { selected, forEach, isFull } from '@/legacy/lib//util';
  import PickerTree from '@/legacy/lib//model/PickerTree';

  export default {
    props: {
      value: Object,
      tree: PickerTree,
      save: String
    },

    data () {
      return {
        selected: {}
      }
    },

    created () {
      this.selectAll (
        this.saved || this.tree.getDefault ()
        //this.tree.getDefault ()
      );
    },

    methods: {
      capitalize,

      /** **/

      selectAll (obj) {
        if (!this.tree.meshes (obj)) {
          this.selected = this.tree.getDefault ();
        } else {
          this.selected = obj;
        }

        this.$emit (
          'input',
          this.selected
        );
      },

      select (label, value) {
        this.selected [label] = value;
        this.selectAll (this.selected);
      },

      /** **/

      options (label) {
        let ptr;
        let l;

        ptr = this.tree.nodes;

        for (l of this.tree.labels) {
          if (l === label) {
            return Object.keys (ptr);
          }

          ptr = ptr [this.selected [l]];
        }

        return [];
      },

      /** **/

      onChange (label) {
        let i;
        let j;
        let l;
        let ptr;

        j = this.tree.labels.indexOf (label);
        ptr = this.tree.nodes;

        for (
          i = 0;
          i < this.tree.labels.length;
          i++
        ) {
          l = this.tree.labels [i];

          if (i > j) {
            this.selected [l] = Object.keys (ptr) [0];
          }

          ptr = ptr [this.selected [l]];
        }

        this.selectAll (
          this.selected
        );

        if (this.save) {
          localStorage.setItem (
            this.save,
            JSON.stringify (this.selected)
          );
        }
      }
    },

    computed: {
      saved () {
        if (!this.save) {
          return null;
        }

        let saved = localStorage.getItem (this.save);

        try {
          saved = JSON.parse (saved);
        } catch (e) {
          saved = null;
        }

        return saved;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .Picker {
    padding: 2em 2em;
    width: 100%;
    // background-image: asset('background/content-red.png');
    background-image: asset('background/dirt-blue.jpg');
    // box-shadow: inset 0 -180px 200px shade($w3s-black, 60);
  }

  select {
    width: 100%;
    margin-top: 5px;
    margin-bottom: 20px;
    font-size: 18px;
  }

  label {
    margin-bottom: 0;
    color: rgba(var(--white), .4);
    // text-align: center;
    width: 100%;
  }
</style>
